import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { withReturnPath } from "../../../utils/navReturn";
import { isRepoUser } from "../../../utils/permissions";
import useAuth from "../../../hooks/useAuth";
import useIsMobile from "../../../hooks/useIsMobile";
import FindVehiclesStatsPanel from "../../../components/findVehicles/FindVehiclesStatsPanel";
import { repoCaseService } from "../../../services/repoCase.service";
import "../../../styles/dashboard.css";

export default function Home() {
  const { auth } = useAuth();
  const location = useLocation();
  const isMobile = useIsMobile();
  const isRepoAdmin = auth?.user?.role === "REPO_ADMIN";
  const isFieldUser = isRepoUser(auth?.user?.role) && !isRepoAdmin;
  const hideAdminStarterCards = isMobile && isRepoAdmin;
  const isRepoStaff = isRepoUser(auth?.user?.role);

  const showHeroIntro = isRepoStaff && !auth?.user?.phone;

  useEffect(() => {
    if (!auth?.token) return;
    repoCaseService.warmSearchCache(auth.token).catch(() => {});
  }, [auth?.token]);

  return (
    <div className="content home-page">
      <section
        className={`home-hero${isRepoStaff ? " home-hero--field-user" : ""}${
          !showHeroIntro ? " home-hero--no-intro" : ""
        }`}
        aria-label="Dashboard overview"
      >
        {showHeroIntro && (
          <div className="home-hero__intro">
            <p className="muted home-hero__hint">
              Add your mobile in <Link to="/profile">Profile</Link> so trace reports
              and bank notify show your contact number.
            </p>
          </div>
        )}

        {isRepoStaff && (
          <FindVehiclesStatsPanel
            className="home-field-stats"
            returnPathFallback="/home"
          />
        )}
      </section>

      <section className="home-actions" aria-label="Quick actions">
        <h3 className="home-section-title">Quick actions</h3>
        <div
          className={`starter-cards home-starter-cards${
            hideAdminStarterCards ? " home-starter-cards--single" : ""
          }${isMobile && isFieldUser ? " home-starter-cards--mobile-user" : ""}`}
        >
          {!hideAdminStarterCards && (
            <>
              <Link to="/bank-details" className="dashboard-card-link">
                <div className="card action-card dashboard-action-card">
                  <div className="action-icon">📁</div>
                  <h4>Agency Upload Repo List Details</h4>
                  <p className="muted small">Upload repo vehicle records</p>
                </div>
              </Link>

              <Link to="/find-vehicles" className="dashboard-card-link">
                <div className="card action-card dashboard-action-card">
                  <div className="action-icon">🚗</div>
                  <h4>Find Vehicles</h4>
                  <p className="muted small">Search vehicle, customer, loan or bank</p>
                </div>
              </Link>
            </>
          )}

          <Link
            to={withReturnPath(
              isRepoAdmin ? "/confirmation?status=PENDING" : "/confirmation?status=CONFIRMED",
              `${location.pathname}${location.search}` || "/home"
            )}
            className="dashboard-card-link"
          >
            <div className="card action-card dashboard-action-card">
              <div className="action-icon">✅</div>
              <h4>Confirmations</h4>
              <p className="muted small">
                {isRepoAdmin
                  ? "Review pending field confirmations"
                  : "View confirmed traces and upload inventory"}
              </p>
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
}
